import {
  SITE_USER_PERMISSIONS,
  SITE_USER_PERMISSION_VALUES,
  SiteUserHasPermissionFor,
} from 'assets/js/api/sites';

export default {
  computed: {
    // disabledForAdminOnly computes whether the input should be disabled.
    disabledForAdminOnly() {
      // Disable the input if admin only and we do not have permission to edit.
      if (this.schema.adminOnly &&
        !SiteUserHasPermissionFor(
          this.site?.permissions,
          SITE_USER_PERMISSIONS.ADMIN_FORM_FIELDS,
          SITE_USER_PERMISSION_VALUES.READ_WRITE,
      )) {
        return true;
      }
      return false;
    },

    // Extracts the site object from the VFG attributes.
    site() {
      if (this.vfg?.site) {
        return this.vfg.site;
      }
      if (this.vfg?.$attrs?.site) {
        return this.vfg.$attrs.site;
      }
      if (this.$attrs?.site) {
        return this.$attrs.site;
      }
      return null;
    },
  },
};
